import Vue from 'vue'

export default function useRecalculation(vm) {
  const state = Vue.observable({
    isLoading: false,
  })

  const buildPayload = (packet, warehouseId) => {
    const products = packet.product.map(item => ({
      product_id: item.product_id,
      total_item: item.qty,
      is_product_bonus: item.is_product_bonus === 1,
      is_bundling: item.is_bundling !== 0,
      storage_type: item.storage_type,
      bundle_components: item.bundle_component?.map(variant => ({
        product_id: variant.product_id,
        qty: variant.qty,
        is_product_bonus: variant.is_product_bonus === 1,
        storage_type: variant.storage_type,
      })),
    }))

    const packings = packet.packings.map(packing => ({
      id: packing.option_id,
      total_layer: packing.packing_layer,
    }))

    return {
      warehouse_id: warehouseId || vm.$route.params.warehouse_id,
      total_order: 1,
      products,
      packings,
    }
  }

  const recalculateFulfillment = async payload => {
    const response = await vm.$http_new.post('/komship/api/v2/orders/recalculate-fulfillment', payload)
    return response.data.data?.fulfillment_cost
  }

  return {
    state,
    recalculateFulfillment,
    buildPayload,
  }
}
